<template>
  <div class="detalhe-container">
    <div class="detalhe-coluna">
      <div class="master-detail-caption">Lotes de Estocagem</div>
      <DxDataGrid
        :data-source="dataSourceLotes"
        :show-borders="true"
        :column-auto-width="true"
        no-data-text="Sem lotes de estocagem"
      >
        <DxSorting
          ascending-text="Ordem crescente"
          descending-text="Ordem descrescente"
          clear-text="Limpar ordenação"
        />
        <DxColumn caption="Lote estocagem" data-field="LoteEstocagem" />
        <DxColumn
          caption="Data da movimentação"
          data-field="DataMovimentacao"
          data-type="date"
        />
        <DxColumn
          caption="Data de vencimento"
          data-field="DataVencimento"
          data-type="date"
        />
        <DxColumn caption="Quantidade" data-field="Quantidade" />
      </DxDataGrid>
    </div>

    <div class="detalhe-coluna">
      <div class="master-detail-caption">Lotes Internos</div>
      <DxDataGrid
        :data-source="dataSourceLotesInternos"
        :show-borders="true"
        :column-auto-width="true"
        no-data-text="Sem lotes internos"
      >
        <DxSorting
          ascending-text="Ordem crescente"
          descending-text="Ordem descrescente"
          clear-text="Limpar ordenação"
        />
        <DxColumn caption="Lote" data-field="Lote" />
        <DxColumn caption="Quantidade" data-field="Quantidade" />
        <DxColumn caption="Valor Unitário" data-field="ValorUnitario" format="R$ #,##0.00" />
        <DxColumn caption="Valor Total" data-field="ValorTotal" format="R$ #,##0.00" />
        <DxColumn caption="Cancelado" data-field="Cancelado" />
      </DxDataGrid>
    </div>
  </div>
</template>

<script>
  import { DxDataGrid, DxColumn, DxSorting } from "devextreme-vue/data-grid";
  import ArrayStore from "devextreme/data/array_store";
  import DataSource from "devextreme/data/data_source";

  export default {
    components: { DxDataGrid, DxColumn, DxSorting },
    props: {
      templateData: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      // Pega o Handle da linha pai (Movimentação)
      movimentacaoHandle() {
        return this.templateData ? this.templateData.Handle : null;
      },
      
      // Filtragem dos Lotes normais
      dataSourceLotes() {
        return new DataSource({
          store: new ArrayStore({
            data: this.$store.state.dadosMovimentacoes.lotes || [],
            key: "LoteEstocagem"
          }),
          filter: ["MovimentacaoHandle", "=", this.movimentacaoHandle]
        });
      },

      // Filtragem dos Lotes Internos
      dataSourceLotesInternos() {
        console.log("DATA", this)
        return new DataSource({
          store: new ArrayStore({
            // Mapeado com base na chave exata do seu JSON (atente-se a maiúsculas/minúsculas no Vuex)
            data: this.$store.state.dadosMovimentacoes.lotesInternos || [],
            key: "Lote"
          }),
          filter: ["MovimentacaoHandle", "=", this.movimentacaoHandle]
        });
      },
    },
  };
</script>

<style scoped>
  /* Alinha as tabelas lado a lado com espaçamento */
  .detalhe-container {
    display: flex;
    gap: 20px;
    padding: 10px;
    width: 100%;
    box-sizing: border-box;
  }

  /* Garante que ambas as colunas ocupem o mesmo espaço (50% cada) */
  .detalhe-coluna {
    flex: 1;
    min-width: 0; /* Evita que o grid quebre o layout flex */
  }

  .master-detail-caption {
    padding: 0 0 8px 5px;
    font-size: 14px;
    font-weight: bold;
    color: #555;
  }
</style>